import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[autofocus]',
    standalone: true
})
export class GtAutofocusDirective implements AfterViewInit {
  private _autofocus;

  constructor(private el: ElementRef) {
  }

  public ngAfterViewInit() {
    if (this._autofocus) {
      this.el.nativeElement.focus();
    }
  }

  @Input() set autofocus(condition: boolean) {
    this._autofocus = condition;
  }
}
